module.exports = __webpack_public_path__ + "img/shape_circle--yellow.24b0d25.webp";